import React from 'react';
var MarkdownIt = require('markdown-it');
var md = new MarkdownIt({
  html: true
});

export default ({ content, className }) => (
  <div
    className={className}
    dangerouslySetInnerHTML={{ __html: md.render(content) }}
  />
);
